export default {
  ROLE_MAP: {
    VM_COMPANY_ADMIN: "Admin",
  },
  EMAIL_VERIFIED_MAP: {
    true: "Verified",
    false: "Unverified",
  },
};
